<!--
 * @Description: 原物料公共检测：快速检测、批次检测、复检、抽检   其他检测
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-06-29 10:32:44
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display:flex">
        <div>
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px;" class="el-icon-arrow-down"></i>
              </span>
              <transition name="to"></transition>
              <span v-show="showCardNav">
                <i style="margin-right: 5px;" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <el-form ref="form" inline :model="tableParam" label-width="80px">
                  <el-form-item label="生成时间">
                    <el-date-picker v-model="tableParam.time1" type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="检测时间">
                    <el-date-picker v-model="tableParam.time" type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="物料">
                    <el-select v-model="tableParam.rawNameId" clearable style="width: 100px;" placeholder="请选择">
                      <el-option v-for="(item, index) in rawList" :key="index" :label="item.itemName"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="站点">
                    <el-select v-model="tableParam.stationId" clearable style="width: 100px;" placeholder="请选择"
                      @change="$forceUpdate()">
                      <el-option v-for="(item, index) in stationList" :key="index" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="规格">
                    <el-select v-model="tableParam.specificationId" clearable style="width: 100px;" placeholder="请选择">
                      <el-option v-for="(item, index) in specificationList" :key="index" :label="item.itemName"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="状态">
                    <el-select v-model="tableParam.dataStatus" clearable style="width: 100px;" placeholder="请选择">
                      <el-option label="待取样" value="0"></el-option>
                      <el-option label="已检测" value="1"></el-option>
                      <el-option label="待检测" value="2"></el-option>
                      <el-option label="审批中" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="searchSubmit()">查
                      询</el-button>
                  </el-form-item>
                  <el-button v-if="dataTypeId === 9" size="medium" class="bottom_all_two" style="margin-left:12px;"
                    @click="add()">添 加</el-button>
                  <el-button size="medium" class="bottom_all_two" style="margin-left:12px;" @click="init()">重
                    置</el-button>
                    <el-button size="medium" class="bottom_three" style="margin-left:12px;" @click="exportList()">导出</el-button>
                  <el-button size="medium" class="bottom_all_two" style="margin-left: 12px"
                    @click="tableParamType = true">高级搜索</el-button>
                </el-form>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" height="500" :cell-style="{ borderRight: 'none' }"
                border stripe :data="tableData" tooltip-effect="dark">
                <el-table-column prop="createTime" label="生成时间" width="165">
                </el-table-column>
                <el-table-column prop="dataType" label="检验类别" width="120">
                </el-table-column>
                <el-table-column prop="carNo" width="90" label="交货车辆">
                </el-table-column>
                <el-table-column prop="dataStatus" label="状态">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.dataStatus === '1'" type="success">已检验</el-tag>
                    <el-tag v-else-if="scope.row.dataStatus === '2'" type="warning">待检验</el-tag>
                    <el-tag v-else-if="scope.row.dataStatus === '3'" style="cursor: pointer;" type="warning"
                      @click="handleToCenterTask">审批中</el-tag>
                    <el-tag v-else-if="scope.row.dataStatus === '4'" type="warning">未通过</el-tag>
                    <el-tag v-else-if="scope.row.dataStatus === '5'" type="warning">已撤销</el-tag>
                    <el-tag v-else type="warning">待取样</el-tag>
                    <el-tag v-if="scope.row.receiveStatus === '0'" type="danger">物流异常</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="supplier" width="200" label="供应商名称">
                </el-table-column>
                <el-table-column prop="rawName" label="物料名称">
                </el-table-column>
                <el-table-column prop="specification" label="规格" width="100">
                </el-table-column>
                <el-table-column prop="brand" label="品牌" width="100">
                </el-table-column>
                <el-table-column prop="field1" label="取样时间" width="165">
                </el-table-column>
                <el-table-column prop="detection" label="检验人">
                </el-table-column>
                <el-table-column prop="detectionTime" label="检验时间" width="165">
                </el-table-column>
                <el-table-column prop="code" label="检验编号" width="160">
                </el-table-column>
                <el-table-column prop="station" label="站点" width="150">
                </el-table-column>
                <el-table-column prop="outcome" label="自动检验结果" width="110">
                </el-table-column>
                <el-table-column label="视频" align="center">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.videoUrl" class="bottom_text" type="text" size="small"
                      @click="handleVideo(scope.row.videoUrl)">查看视频</el-button>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column prop="contractNo" width="220" label="合同编号">
                </el-table-column>
                <el-table-column prop="logisticsNo" width="150" label="物流单号">
                </el-table-column>
                <el-table-column fixed="right" min-width="100" label="操作" align="center">
                  <template slot-scope="scope">
                    <el-dropdown :hide-on-click="false" trigger="click">
                      <el-button size="mini" class="bottom_one">更多</el-button>
                      <el-dropdown-menu slot="dropdown" style="text-align: left">
                        <el-dropdown-item
                          v-if="scope.row.dataStatus === '0' && ButtonList.findIndex(res => (res.buttonValue == 'QUYANG')) !== -1">
                          <el-button style="margin:5px 0" class="bottom_one" size="mini"
                            @click="makeupdStatusFun(scope.row);">
                            取样
                          </el-button>
                        </el-dropdown-item>
                        <!-- <el-dropdown-item v-if="dataTypeId === 4 && scope.row.dataStatus !== '0'&&ButtonList.findIndex(res=>(res.buttonValue=='DAYIN'))!==-1">
                          <el-button style="margin:5px 0" class="bottom_one" size="mini" @click="handlePrint(scope.row);">
                            打印标签
                          </el-button>
                        </el-dropdown-item> -->
                        <el-dropdown-item v-if="['0', '1', '2', '3'].includes(scope.row.dataStatus)">
                          <el-button style="margin:5px 0" class="bottom_one" size="mini" @click="handlePrint(scope.row);">
                            打印标签
                          </el-button>
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="(scope.row.dataStatus === '2' || scope.row.dataStatus === '4' || scope.row.dataStatus === '5') && ButtonList.findIndex(res => (res.buttonValue == 'JIANCELR')) !== -1">
                          <el-button style="margin:5px 0" class="bottom_one" size="mini"
                            @click="checkOutIn(scope.row, false,);">
                            检测录入
                          </el-button>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="scope.row.dataStatus === '1'">
                          <el-button style="margin:5px 0" class="bottom_one" size="mini"
                            @click="handleDetails(scope.row)">
                            查看
                          </el-button>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="scope.row.dataStatus === '1'">
                          <el-button style="margin:5px 0" class="bottom_one" size="mini"
                            @click="checkOutIn(scope.row, false, true)">
                            修改
                          </el-button>
                        </el-dropdown-item>
                        <!-- <el-dropdown-item v-if="ButtonList.findIndex(res=>(res.buttonValue=='QITAJIANC'))!==-1&&dataTypeId!==3">
                          <el-button style="margin:5px 0" class="bottom_one" size="mini" @click="otherCheckOut(scope.row)">
                            其他检测
                          </el-button>
                        </el-dropdown-item> -->
                        <el-dropdown-item v-if="scope.row.dataStatus == 0">
                          <el-button style="margin:5px 0" class="bottom_one" size="mini"
                            @click="queryListBysupplierIdFun(scope.row)">
                            修改计划
                          </el-button>
                        </el-dropdown-item>
                        <el-dropdown-item v-show="dataTypeId === 3">
                          <el-button style="margin:5px 0" class="bottom_one" size="mini" @click="checkHistory(scope.row)">
                            检测历史
                          </el-button>
                        </el-dropdown-item>
                        <el-dropdown-item v-show="dataTypeId === 1">
                          <el-button style="margin:5px 0" class="bottom_one" size="mini"
                            @click="changeHistory(scope.row)">
                            修改记录
                          </el-button>
                        </el-dropdown-item>
                        <!-- <el-dropdown-item v-show="dataTypeId===9">
                          <el-button style="margin:5px 0" class="bottom_one" size="mini" @click="edit(scope.row)">
                            修 改
                          </el-button>
                        </el-dropdown-item> -->
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 视频查看 -->
    <el-dialog v-dialogDrag :visible.sync="Dialog1" width="980px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">图片信息</span>
      <div class="dialoginfo">
        <div>
          <el-image v-for="(item, index) in arr1" :key="index"
            style="width: 200px; height:200px;margin:0 10px 10px 10px;border-radius: 4px;" :src="item"
            :preview-src-list="arr1" :z-index="10000"></el-image>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="Dialog1 = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 其他检测 -->
    <el-dialog v-dialogDrag :visible.sync="checkTypeVisible" width="450px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">其他检测</span>
      <div class="dialoginfo">
        <el-form>
          <el-form-item label="检测类别">
            <el-select v-model="checkType" placeholder="检测类别">
              <el-option v-for="item in checkOutType" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="checkTypeVisible = false">取 消</el-button>
        <el-button class="bottom_all" @click="changeCheckType">确定</el-button>
      </span>
    </el-dialog>
    <!-- 检测录入及查看 -->
    <!-- <el-dialog v-dialogDrag :visible.sync="visible" width="880px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">{{`检测${readOnly?'查看':'录入'}`}}</span>
      <div>
        <div class="dialoginfo-title">
          <div>
            <span>供应商：</span>
            <span>{{checkOutData.supplierName}}</span>
          </div>
          <div>
            <span>原物料：</span>
            <span>{{checkOutData.rawName}}</span>
          </div>
          <div>
            <span>车牌号：</span>
            <span>{{checkOutData.carNo}}</span>
          </div>
        </div>
        <el-table v-if="!readOnly" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="dataSource" tooltip-effect="dark" height="100%">
          <template v-for="(item, index) in tableNav">
            <el-table-column :key="index" :label="item.NAME || item.name" align="center" :width="index == 0 ? '120px' : 'auto'">
              <template slot-scope="scope">
                <span v-if="index == 0" :style="colorStyle(scope.row[index].name)">{{ scope.row[index].name || scope.row[index].testItem}}</span>
                <div v-if="index !== 0 && scope.row[index]">
                  <el-select v-if="(scope.row[index].dataType||scope.row[index].type)== 1" v-model="scope.row[index].testValue" placeholder="请选择" style="width:100%">
                    <el-option v-for="(item, index) in scope.row[index].list" :key="index" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                  <el-input v-if="(scope.row[index].dataType||scope.row[index].type) == 2" v-model="scope.row[index].testValue" style="width:100%" placeholder="请输入" clearable></el-input>
                  <span v-if="(scope.row[index].dataType||scope.row[index].type) == 3">
                    <span>
                      <el-input v-model="scope.row[index].testValue" type="Number" style="width: 90px;margin-left: 5px;" placeholder="请输入" clearable></el-input>
                    </span>
                  </span>
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <el-table v-if="readOnly" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="dataSource" tooltip-effect="dark" height="100%">
          <template v-for="(item, index) in tableNav">
            <el-table-column :key="index" :label="item.NAME || item.name" align="center" :width="index == 0 ? '120px' : 'auto'">
              <template slot-scope="scope">
                <span v-if="index == 0">{{ scope.row[index].name || scope.row[index].testItem}}</span>
                <div v-if="index !== 0 && scope.row[index]">
                  <el-select v-if="(scope.row[index].dataType||scope.row[index].type)== 1" v-model="scope.row[index].testValue" disabled placeholder="请选择" style="width:100%">
                    <el-option v-for="(item, index) in scope.row[index].list" :key="index" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                  <el-input v-else-if="(scope.row[index].dataType||scope.row[index].type) == 2" v-model="scope.row[index].testValue" disabled style="width:100%" placeholder="请输入" clearable></el-input>
                  <span v-else-if="(scope.row[index].dataType||scope.row[index].type) == 3">
                    <span>
                      <el-input v-model="scope.row[index].testValue" disabled type="Number" style="width: 90px;margin-left: 5px;" placeholder="请输入" clearable></el-input>
                    </span>
                  </span>
                  <span v-else>
                    <span v-if="scope.row[index].dataTypes===3">{{scope.row[index].symbol }} </span>
                    {{scope.row[index].testItem}}</span>
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <el-row type="flex" style="margin-top: 30px;">
          <el-col style="width:50px;">备注：</el-col>
          <el-col>
            <el-input v-model="remark" :disabled="readOnly" type="textarea" :rows="2" placeholder="请输入内容">
            </el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="visible=false">取 消</el-button>
        <el-button v-show="!readOnly" class="bottom_all" @click="checkInSubmit">提交录入</el-button>
      </span>
    </el-dialog> -->
    <!-- 检测历史 -->
    <el-dialog v-dialogDrag :visible.sync="historyVisible" width="80%" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">检测历史</span>
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
        style="width:100%" :data="historyData" tooltip-effect="dark">
        <el-table-column prop="code" label="检验编号">
        </el-table-column>
        <el-table-column prop="station" label="站点">
        </el-table-column>
        <el-table-column prop="dataType" label="检测类型"></el-table-column>
        <el-table-column prop="supplierName" label="供应商名称">
        </el-table-column>
        <el-table-column prop="rawName" label="物料名称">
        </el-table-column>
        <el-table-column prop="specification" label="规格">
        </el-table-column>
        <el-table-column prop="carNo" label="交货车辆">
        </el-table-column>
        <el-table-column prop="detectionTime" label="检验时间">
        </el-table-column>
        <el-table-column fixed="right" label="检测结果">
          <template slot-scope="scope">
            <el-button class="bottom_all" type="text" size="small" @click="handleDetails(scope.row);">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="historyVisible = false">取 消</el-button>
        <el-button class="bottom_all" @click="historyVisible = false">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :close-on-click-modal="false" title="结果判断" :visible.sync="dialogVisible" width="40%">
      <div v-if="result">
        系统检测结果为： OK
      </div>
      <div v-else>
        系统检测结果为： NG
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="!result" class="bottom_all" type="primary" @click="handleToFlow">进入审核</el-button>
        <el-button v-else class="bottom_all" type="primary" @click="handleSure">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改计划 -->
    <el-dialog v-dialogDrag :visible.sync="modifyType5" width="450px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">修改计划</span>
      <div class="dialoginfo">
        <el-form ref="modifyForm5" :model="modifyForm5" label-width="100px">
          <el-form-item label="供应计划：" prop="planId" :rules="[{ required: true, message: '请选择供应计划', trigger: 'change', }]">
            <el-select v-model="modifyForm5.planId" @change="planIdFun(modifyForm5.planId)">
              <el-option v-for="item in planIdList" :key="item.id" :label="item.station + '_' + item.rawName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="站点：">
            <span>{{ modifyForm5.station }}</span>
          </el-form-item>
          <el-form-item label="供应商名称：">
            <span>{{ modifyForm5.supplierName }}</span>
          </el-form-item>
          <el-form-item label="原物料名称：">
            <span>{{ modifyForm5.rawName }}</span>
          </el-form-item>
          <el-form-item label="原物料规格：">
            <span>{{ modifyForm5.specification }}</span>
          </el-form-item>
          <el-form-item label="需求时间：">
            <span>{{ modifyForm5.needDate }}</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="modifyType5 = false">取 消</el-button>
        <el-button class="bottom_all" @click="makeupdatePlanFun()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 修改明细 -->
    <el-dialog v-dialogDrag :visible.sync="changeHistoryDig" width="780px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">修改明细</span>
      <div class="dialoginfo">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in changeHistoryData" :key="index" :timestamp="activity.createTime">
            {{ activity.createUserName }}<span style="color: red;margin-left: 24px;">库存仓:</span>{{ activity.warehouseName }}<span style="color: red;margin-left: 24px;">含水率:</span>{{activity.moistureContent}}
          </el-timeline-item>
        </el-timeline>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="changeHistoryDig = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 高级搜索 -->
    <el-dialog v-dialogDrag :visible.sync="tableParamType" width="650px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">高级搜索</span>
      <div class="dialoginfo">
        <el-form ref="reftableParam" :inline="true" :model="tableParam" label-width="110px">
          <el-form-item>
            <span slot="label">交货车辆</span>
            <el-input v-model="tableParam.carNo" tplaceholder="请输入" clearable style="width:400px;"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">检验人</span>
            <el-input v-model="tableParam.detection" tplaceholder="请输入" clearable style="width:400px;"></el-input>
          </el-form-item>
          <el-form-item v-if="dataTypeId == 1 || dataTypeId == 2">
            <span slot="label">检验时间</span>
            <el-date-picker v-model="startTimDateEndTimDate" type="datetimerange" unlink-panels
              value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"
              @change="tableParam.createTime = startTimDateEndTimDate[0] || '', tableParam.updateTime = startTimDateEndTimDate[1] || ''"></el-date-picker>
          </el-form-item>
          <el-form-item v-if="dataTypeId != 1">
            <span slot="label">合同编号</span>
            <el-input v-model="tableParam.contractNo" tplaceholder="请输入" clearable style="width:400px;"></el-input>
          </el-form-item>
          <el-form-item v-if="dataTypeId != 1">
            <span slot="label">供应商名称</span>
            <el-input v-model="tableParam.supplierName" tplaceholder="请输入" clearable style="width:400px;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two"
          @click="tableParamType = false, tableParam.carNo = '', tableParam.detection = '', startTimDateEndTimDate = [], tableParam.createTime = '', tableParam.updateTime = '', tableParam.contractNo = '', tableParam.supplierName = ''">取
          消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="gettableData(), tableParamType = false">搜
          索</el-button>
      </span>
    </el-dialog>
    <div id="print">
      <el-row style="padding-top:60px;">
        <el-col :span="12">{{ printData.rawName }}</el-col>
        <el-col :span="12">{{ printData.code }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="12">{{ printData.specification }}</el-col>
        <el-col :span="12">{{ printData.samplingDate }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="12">{{ printData.sendUnit }}</el-col>
        <el-col :span="12">{{ printData.recUnit }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="12">{{ printData.carNo }}</el-col>
        <el-col :span="12">{{ printData.warehouse }}</el-col>
      </el-row>
      <el-row></el-row>
      <el-row>
        <el-col v-if="dataTypeId == 8 && isSpecialMaterial(printData.rawName)">一式四份,每份不低于6kg</el-col>
        <el-col v-else-if="dataTypeId == 2 && isSpecialMaterial(printData.rawName)">批次取样 一式二份,每份不低于6kg</el-col>
      </el-row>
    </div>
    <!-- 查看图片 -->
    <ShowDetails :dialog="imgsDialog" :imgList="imgList" :mp4List="mp4List" @reset="imgsDialog = false"></ShowDetails>

    <!-- 快检录入 -->
    <RapidTestDialog :visible.sync="rapidTestVisible" :config="rapidTestConfig" :checkOutData="checkOutData"
      :isChange="isChange" @updated="gettableData()" @check="(query) => { this.handleToFlow(query) }" />
    <!-- 其他检测录入 -->
    <QualityTemplateDialog :visible.sync="qualityTemplateVisible" :config="qualityTemplateConfig"
      :checkOutData="checkOutData" :isChange="isChange" @check="(query) => { this.handleToFlow(query) }" />
    <!-- 送检录入列表数据 -->
    <AddInspectDialog :visible.sync="addInspectVisible" :config="addInspectConfig" @updated="init" />
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { getDicType, getUserAutList } from "@/api/common.js";
import { queryPage, 
// Download,
 exportPage,queryOtherPage, getListByPid } from "@/api/smart/checkout.js";
import { getStationNormByDetection, getCheckoutType, createOther, getCheckResult, saveCheckOutResult, makeupdStatus, countCheckResult, queryListBysupplierId, makeupdatePlan, getPrintData, queryResord } from '@/api/smart/checkout';
import ShowDetails from '@/components/showdetails';
import RapidTestDialog from "./components/RapidTestDialog.vue"
import QualityTemplateDialog from "./components/QualityTemplateDialog.vue"
import AddInspectDialog from './components/AddInspectDialog'
import { getUserInfo } from "@/utils/auth";
export default {
  props: ['dataTypeId', 'dataTypeStatus', 'printDetail'],
  mixins: [mixin],
  components: {
    ShowDetails,
    RapidTestDialog,
    QualityTemplateDialog,
    AddInspectDialog
  },
  data() {
    return {
      addInspectVisible: false,
      addInspectConfig: {},
      rapidTestVisible: false,
      rapidTestConfig: {},
      qualityTemplateVisible: false,
      qualityTemplateConfig: {},
      startTimDateEndTimDate: [],
      tableParamType: false,
      imgsDialog: false,
      imgList: [],
      mp4List: [],
      queryPage: queryPage,
      DownloadURL: exportPage,
      Dialog1: false,
      Dialog2: false,
      pagesType: 0,
      arr1: [],
      checkOutData: {},
      readOnly: false,
      visible: false,
      checkTypeVisible: false,
      tableNav: [],
      dataSource: [],
      remark: '',
      checkOutType: [],
      checkType: '',
      checkId: '',
      consignmentId: '',
      dialogVisible: false,
      result: '',
      historyData: [],
      historyVisible: false,
      modifyType5: false,
      planIdList: [],
      modifyForm5: { planId: '', id: '' },
      printData: {},
      stationList: [],
      specificationList: [],
      rawList: [],
      isChange: false,
      changeHistoryDig: false,
      changeHistoryData:[],
    };
  },
  async created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.UserInfo = await getUserInfo();
    if (this.dataTypeStatus) { // 其他检测
      this.queryPage = queryOtherPage;
      this.tableParam = { ...this.tableParam, dataTypeStatus: 1, };
    } else {
      this.tableParam = { ...this.tableParam, dataTypeId: this.dataTypeId, };
    }
    this.tableParam = { ...this.tableParam, carNo: '', detection: '', createTime: '', updateTime: '', contractNo: '', supplierName: '', rawNameId: '', specificationId: '', startQueryTime: "", endQueryTime: "" }
    this.stationList = await getUserAutList(true);
    this.init();
    getDicType({ code: "MATspec" }).then((res) => {
      this.specificationList = res.data.items; //
    });
    getDicType({ code: "MATname" }).then((res) => {
      this.rawList = res.data.items;
    });
  },
  methods: {
    // 判断是否为特殊物料（需要一式四份）
    isSpecialMaterial(rawName) {
      if (!rawName) return false;
      const keywords = ['胶凝材料', '水泥', '煤灰', '矿粉', '复合'];
      return keywords.some(keyword => rawName.includes(keyword));
    },
    //修改历史
    changeHistory(row) {
      queryResord({id:row.id}).then( res => {
        if(res.code == 1001) {
          this.changeHistoryDig = true
          this.changeHistoryData = res.data
        }
      })
      
    },
    // 送检添加
    add() {
      this.addInspectConfig = {
        type: 'add',
        data: {}
      }
      this.addInspectVisible = true;
    },
    // 送检修改
    edit(row) {
      this.addInspectConfig = {
        type: 'edit',
        data: { ...row }
      }
      this.addInspectVisible = true;
    },
    colorStyle(name) {
      if (this.checkOutData.rawName === '碎石' && (name === '含泥量/%' || name === '颗粒级配')) {
        return ("color: #F56C6C")
      }
      if ((this.checkOutData.rawName === '天然砂' || this.checkOutData.rawName === '机制砂') && (name === '石粉含量/%' || name === '含水率/%' || name === 'MB值')) {
        return ("color: #F56C6C")
      }
    },
    handleToCenterTask() {
      this.$router.push({ name: 'iama' });
    },
    planIdFun(id) {
      let item = this.planIdList.find((res) => res.id == id)
      this.modifyForm5.station = item.station
      this.modifyForm5.supplierName = item.supplierName
      this.modifyForm5.rawName = item.rawName
      this.modifyForm5.specification = item.specification
      this.modifyForm5.needDate = item.needDate
    },
    /**打开修改计划 */
    queryListBysupplierIdFun(row) {
      this.$nextTick(() => { this.$refs.modifyForm5.clearValidate() });
      this.$data.modifyForm5 = this.$options.data().modifyForm5
      this.modifyForm5.id = row.id
      this.modifyType5 = true
      queryListBysupplierId({ supplierId: row.supplierId }).then((res) => {
        this.planIdList = res.data
      })
    },
    /**提交修改计划 */
    makeupdatePlanFun() {
      this.$refs.modifyForm5.validate((valid) => {
        if (valid) {
          makeupdatePlan(this.modifyForm5).then((res) => {
            if (res.code == 1001) {
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.modifyType5 = false
              this.gettableData();
            }
          })
        } else {
          return false;
        }
      });
    },
    exportList() {
      let parmam = this.tableParam
      parmam.pageSize = 100000
      this.$Download(this.DownloadURL, parmam);
    },
    init() {
      this.tableParam.time = ''
      this.tableParam.time1 = this.setDefaultTime()
      this.tableParam.dataStatus = ''
      this.tableParam.rawNameId = ''
      this.tableParam.specificationId = ''
      if (this.UserInfo.pointIds.length > 0) {
        this.tableParam.stationId = this.UserInfo.pointIds[0];
      } else {
        this.tableParam.stationId = this.stationList[0].id;
      }
      this.searchSubmit()
    },
    makeupdStatusFun(d) {
      this.$confirm('是否确认取样?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'bottom_all_two',
        confirmButtonClass: 'bottom_all',
        type: 'warning'
      }).then(() => {
        let json = {
          id: d.id,
          dataStatus: 2
        }
        makeupdStatus(json).then((res) => {
          if (res.code == 1001) {
            this.searchSubmit()
          }
        })
      }).catch(() => {
      });
    },
    async handlePrint(data) {
      await getPrintData({ code: data.code }).then(res => {
        if (res.code === 1001) {
          this.printData = res.data;

        }
      })
      const dom = document.querySelector('#print');
      let copyDom = document.createElement('span')
      const styleDom = document.querySelectorAll('style, link, meta')
      Array.from(styleDom).forEach(item => {
        copyDom.appendChild(item.cloneNode(true))
      })
      copyDom.appendChild(dom.cloneNode(true))
      const htmlTemp = copyDom.innerHTML
      console.log(htmlTemp)
      copyDom = null
      // 打开新窗口显示内容
      const newWindow = window.open('', '_blank');
      newWindow.document.write(`<!doctype html>`);
      newWindow.document.write(htmlTemp);
      newWindow.document.close();
      // newWindow.print();
    },
    searchSubmit() {
      if (this.tableParam?.time?.length) {
        this.tableParam.createTime = this.tableParam.time[0]
        this.tableParam.updateTime = this.tableParam.time[1]
      } else {
        this.tableParam.createTime = ''
        this.tableParam.updateTime = ''
      }
      if (this.tableParam?.time1?.length) {
        this.tableParam.startQueryTime = this.tableParam.time1[0]
        this.tableParam.endQueryTime = this.tableParam.time1[1]
      } else {
        this.tableParam.startQueryTime = ''
        this.tableParam.endQueryTime = ''
      }
      this.gettableData();
    },
    handleVideo(url) {
      if (!url) {
        this.$message.warning('视频为空')
        return
      }
      let items = url.split(",").map(res => ('/file/' + res))
      this.imgList = items.filter(res => (res.includes('type=img')))
      this.mp4List = items.filter(res => (res.includes('type=mp4')))
      this.imgsDialog = true
    },
    checkOutIn(data, isReadOnly, isChange) {
      this.remark = '';
      this.checkId = data.id;
      this.consignmentId = data.consignmentId;
      console.log(data);
      const params = {
        id: data.dataTypeId,
        dataSources: 2,
        rawId: data.rawId,
        specification: data.specification,
        type: 1,
        stationId: data.stationId,
      }
      getStationNormByDetection(params).then(res => {
        if (res.code === 1001) {
          // data.rawName = '聚丙烯纤维'
          this.checkOutData = data;
          if (this.dataTypeId === 1) {
            this.rapidTestVisible = true;
            this.isChange = isChange;
            this.rapidTestConfig = {
              ...data,
              dataTypeId: this.dataTypeId,
              consignmentId: this.consignmentId,
              type: 1,
              isReadOnly: !!isReadOnly
            }
          } else {
            this.qualityTemplateVisible = true;

            this.qualityTemplateConfig = {
              ...data,
              dataTypeId: this.dataTypeId,
              consignmentId: this.consignmentId,
              type: 1,
              isReadOnly: !!isReadOnly
            }
          }

        }
      })
    },
    handleDetails(row) {
      this.checkOutIn(row, true)
      // if(this.dataTypeId === 1) {
      //   console.log(123)
      //   this.handleDetails2(row)
      // } else {
      //   this.checkOutIn(row, true)
      // }
    },
    /**
     * 作废
     * @Description: 查看数据详情
     * @Param: 
     * @Author: wangwangwang
     */
    handleDetails2(data) {
      const params = {
        pid: data.id,
      }
      this.remark = data.handleDetails;
      getCheckResult(params).then(res => {
        if (res.code === 1001) {
          this.checkOutData = data;
          this.rapidTestVisible = true;
          this.rapidTestConfig = {
            ...data,
            dataTypeId: this.dataTypeId,
            consignmentId: this.consignmentId,
            type: 1,
            disabled: true
          }
        }
      })
    },
    /**
     * @Description: 获取其他检测的检测类别
     * @Param: 
     * @Author: wangwangwang
     */
    otherCheckOut(data) {
      const params = {
        rawId: data.rawNameId,
        type: 1,
        specification: data.specification,
        companyId: data.stationId,
      }
      this.checkType = '';
      this.checkOutData = data;
      getCheckoutType(params).then(res => {
        if (res.code === 1001) {
          this.checkOutType = res.data;
          this.checkOutType.forEach((v, k) => {
            if (this.dataTypeId == 1 && v.id == 1) {
              this.checkOutType.splice(k, 1)
            } else if (this.dataTypeId == 2 && v.id == 2) {
              this.checkOutType.splice(k, 1)
            } else if (this.dataTypeId == 3 && v.id == 3) {
              this.checkOutType.splice(k, 1)
            } else if (this.dataTypeId == 4 && v.id == 4) {
              this.checkOutType.splice(k, 1)
            }
          })
          this.checkTypeVisible = true;
        }
      })
    },
    /**
     * @Description: 检测历史
     * @Param: 
     * @Author: wangwangwang
     */
    checkHistory(data) {
      const params = {
        consignmentId: data.consignmentId
      }
      getListByPid(params).then(res => {
        if (res.code === 1001) {
          this.historyVisible = true;
          this.historyData = res.data;
        }
      })
    },
    checkInSubmit() {
      if (this.checkOutData.rawName === '碎石') {
        for (let i = 0; i < this.dataSource.length; i += 1) {
          if (this.dataSource[i][0].name === '颗粒级配' && !this.dataSource[i][1].testValue) {
            this.$message.warning('颗粒级配不能为空！！！')
            return
          }
          if (this.dataSource[i][0].name === '含泥量/%' && !this.dataSource[i][1].testValue) {
            this.$message.warning('含泥量/%不能为空！！！')
            return
          }
        }
      }
      if (this.checkOutData.rawName === '机制砂' || this.checkOutData.rawName === '天然砂') {
        for (let i = 0; i < this.dataSource.length; i += 1) {
          if (this.dataSource[i][0].name === '石粉含量/%' && !this.dataSource[i][1].testValue) {
            this.$message.warning('石粉含量/%不能为空！！！')
            return
          }
          if (this.dataSource[i][0].name === '含水率/%' && !this.dataSource[i][1].testValue) {
            this.$message.warning('含水率/%不能为空！！！')
            return
          }
          if (this.dataSource[i][0].name === 'MB值' && !this.dataSource[i][1].testValue) {
            this.$message.warning('MB值不能为空！！！')
            return
          }
        }
      }
      const copyData = JSON.parse(JSON.stringify(this.tableNav));
      copyData.shift();
      const params = {
        id: this.checkOutData.id,
        typeId: this.checkOutData.dataTypeId,
        claim: copyData,
        list: this.dataSource,
      }
      /**
       * @Description: 录入检测结果、如果结果为NG 则流程
       * @Param: 
       * @Author: wangwangwang
       */
      countCheckResult(params).then(res => {
        if (res.code === 1001) {
          this.visible = false;
          console.log(res.data);
          this.result = res.data;
          this.dialogVisible = true;
        }
      })
    },
    /**
     * @Description: 选择其他检测类型
     * @Param: 
     * @Author: wangwangwang
     */
    changeCheckType() {
      let dataType = ''
      for (let i = 0; i < this.checkOutType.length; i += 1) {
        if (this.checkOutType[i].id === this.checkType) {
          dataType = this.checkOutType[i].name
        }
      }
      const params = {
        id: this.checkOutData.id,
        dataTypeId: this.checkType,
        dataType,
        dataTypeStatus: 1,
      }
      createOther(params).then(res => {
        if (res.code === 1001) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.checkTypeVisible = false;
          this.gettableData();
        }
      })
    },
    /**
     * @Description: 结果为OK点击确定改变状态
     * @Param: 
     * @Author: wangwangwang
     */
    handleSure() {
      const copyData = JSON.parse(JSON.stringify(this.tableNav));
      copyData.shift();
      const params = {
        id: this.checkOutData.id,
        typeId: this.checkOutData.dataTypeId,
        claim: copyData,
        remark: this.remark,
        outcome: 'OK',
        list: this.dataSource,
        type: 1
      }
      /**
       * @Description: 录入检测结果、如果结果为NG 则流程
       * @Param: 
       * @Author: wangwangwang
       */
      saveCheckOutResult(params).then(res => {
        if (res.code === 1001) {
          this.dialogVisible = false;
          console.log(res.data);
          this.result = res.data;
          this.gettableData();
          this.$message.success('检测已录入');
        }
      })
    },
    /**
     * @Description: 结果为NG进入审核
     * @Param: 
     * @Author: wangwangwang
     */
    handleToFlow(query) {
      const params = {
        dataTypeId: this.dataTypeId,
        rawNameId: this.checkOutData.rawNameId,
        stationId: this.checkOutData.stationId,
        supplierName: this.checkOutData.supplierName,
        rawName: this.checkOutData.rawName,
        carNo: this.checkOutData.carNo,
        contractId: this.checkOutData.contractId,
        rawId: this.checkOutData.rawId,
        id: this.checkOutData.id,
        consignmentId: this.consignmentId,
        type: 1,
        remark: this.remark,
        ...query ? query : {}
      }
      this.dialogVisible = false;
      this.$router.push({ name: "checkflows", query: params });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo-title {
  display: flex;
  justify-content: space-between;
  padding: 10px 0 20px 0;
  font-weight: bold;
}

.el-input,
.el-select {
  width: 240px;
}

.table_link {
  margin: 0 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}

#print {
  width: 500px;
  text-align: center;

  >div {
    margin: 20px 0;
  }
}

.demo-form-inline {
  .el-form-item {
    margin-right: 0px;
    width: 33%;
  }
}

.remark {
  display: flex;
  margin-top: 20px;

  .name {
    width: 60px;
    text-align: right;
  }

  .input {
    flex: 1;
  }
}
</style>
